import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { OAuthProvider } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function oauthProvider(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(OAuthProvider))),
    });
    const callbackResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parsers.parseArrayBufferResponse),
    });
    return Object.freeze({
        /**
         * Get all OAuth providers connected to this instance.
         *
         * @returns All connected providers.
         */
        getAll: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/oauth_providers/`, getAllResponse.v, undefined);
            return result;
        },
        /**
         * The method that is used by OAuth providers after they completed the login flow.
         *
         * For the precise meaning of the query parameters see RFC 6749.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The id of the OAuthProvider that completed the flow.
         * @param arg.state The state.
         * @param arg.code The code.
         * @param arg.error The error.
         * @param arg.errorDescription The description of the error.
         * @returns A response that is not in any defined format.
         */
        callback: async ({ providerId, state = undefined, code = undefined, error = undefined, errorDescription = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/oauth_providers/${providerId}/callback`, callbackResponse.v, undefined, {
                state,
                code,
                error,
                error_description: errorDescription,
            });
            return result;
        },
    });
}
